module.exports = __webpack_public_path__ + "img/icone-blockchain-verde.2b12278a.png";